import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { formatPrice } from "@/data/product";

export default function StickyBuyBar({ variant, onBuy }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 650);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 90 }}
                    animate={{ y: 0 }}
                    exit={{ y: 90 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    data-testid="sticky-buy-bar"
                    className="fixed bottom-0 inset-x-0 z-40 md:hidden backdrop-blur-2xl bg-black/70 border-t border-white/10 px-4 py-3 flex items-center gap-3"
                >
                    <img src={variant.image} alt={variant.name} className="w-11 h-11 rounded-xl object-cover border border-white/10" />
                    <div className="flex-1 min-w-0">
                        <p className="text-xs font-semibold truncate">{variant.name} — {variant.edition}</p>
                        <p className="text-sm font-display text-cyan-300" data-testid="sticky-bar-price">{formatPrice(variant.price)}</p>
                    </div>
                    <button
                        onClick={onBuy}
                        data-testid="sticky-bar-buy-button"
                        className="rounded-full bg-cyan-300 text-black text-xs font-bold uppercase tracking-[0.12em] px-6 py-3 active:scale-95 transition-transform"
                    >
                        Buy Now
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
